exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1abb2526] .modeltree__select{width:440px}[data-v-1abb2526] .modeltree__select .el-select-dropdown__empty{display:none}", ""]);

// exports
